document.addEventListener("DOMContentLoaded", function() {
  const swatchItems = document.querySelectorAll(".swatch-item");
  const label = document.querySelector("[id^='swatch-product-title-']");
  const activeSwatch = document.querySelector(".swatch-item.active");
  if (!swatchItems.length || !label || !activeSwatch) return;

  // Default label = active product metafield
  const defaultText = activeSwatch.getAttribute("data-title");
  label.innerText = defaultText;

  swatchItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      label.innerText = item.getAttribute("data-title");
    });
    item.addEventListener("mouseleave", () => {
      label.innerText = defaultText;
    });
  });
});